// Here we will embed the WordPress RowingGuide site

function RowingGuideDemo() {
    return (
        <div>
        </div>
    )
}

export default RowingGuideDemo;